import { useStore } from "../store/useStore";
import { CognitoGroups } from "../models/CognitoUser";
import { RoleService } from "../util/role-service/role-service";

const useRoleAccess = () => {
  const { state } = useStore();
  const { user } = state;

  const hasRoles = (roles?: CognitoGroups[]) => {
    return new RoleService().hasRoles(roles, user);
  };

  return { hasRoles };
};

export default useRoleAccess;
